import BubbleChat from "./bubble-chat";
import BubbleChatAdd from "./bubble-chat-add";
import BubbleChatBlocked from "./bubble-chat-blocked";
import BubbleChatCancel from "./bubble-chat-cancel";
import BubbleChatDelay from "./bubble-chat-delay";
import BubbleChatDone from "./bubble-chat-done";
import BubbleChatDownload01 from "./bubble-chat-download-01";
import BubbleChatDownload02 from "./bubble-chat-download-02";
import BubbleChatEdit from "./bubble-chat-edit";
import BubbleChatFavourite from "./bubble-chat-favourite";
import BubbleChatIncome from "./bubble-chat-income";
import BubbleChatLock from "./bubble-chat-lock";
import BubbleChatNotification from "./bubble-chat-notification";
import BubbleChatOutcome from "./bubble-chat-outcome";
import BubbleChatPreview from "./bubble-chat-preview";
import BubbleChatQuestion from "./bubble-chat-question";
import BubbleChatSearch from "./bubble-chat-search";
import BubbleChatSecure from "./bubble-chat-secure";
import BubbleChatTranslate from "./bubble-chat-translate";
import BubbleChatUnlock from "./bubble-chat-unlock";
import BubbleChatUpload from "./bubble-chat-upload";
import BubbleChatUser from "./bubble-chat-user";
import Chatting01 from "./chatting-01";
import Comment01 from "./comment-01";
import Comment02 from "./comment-02";
import CommentRemove02 from "./comment-remove-02";
import MailOpen from "./mail-open";
import MailOpen01 from "./mail-open-01";
import MailOpen02 from "./mail-open-02";
import MailOpenLove from "./mail-open-love";
import Message02 from "./message-02";
import MessageBlocked from "./message-blocked";
import MessageDone02 from "./message-done-02";
import WeChat from "./wechat";

export * from "./comment-01";
export * from "./bubble-chat";
export * from "./message-02";
export * from "./chatting-01";
export * from "./bubble-chat-done";
export * from "./wechat";
export * from "./bubble-chat-lock";
export * from "./bubble-chat-secure";
export * from "./bubble-chat-unlock";
export * from "./bubble-chat-blocked";
export * from "./bubble-chat-add";
export * from "./bubble-chat-cancel";
export * from "./bubble-chat-download-01";
export * from "./bubble-chat-download-02";
export * from "./bubble-chat-income";
export * from "./bubble-chat-notification";
export * from "./bubble-chat-outcome";
export * from "./bubble-chat-preview";
export * from "./bubble-chat-question";
export * from "./bubble-chat-translate";
export * from "./bubble-chat-upload";
export * from "./bubble-chat-user";
export * from "./bubble-chat-edit";
export * from "./message-done-02";
export * from "./bubble-chat-favourite";
export * from "./bubble-chat-search";
export * from "./bubble-chat-delay";
export * from "./comment-02";
export * from "./mail-open";
export * from "./mail-open-01";
export * from "./mail-open-02";
export * from "./message-blocked";
export * from "./comment-remove-02";
export * from "./mail-open-love";

export const Chats = {
  Comment01,
  BubbleChat,
  Message02,
  Chatting01,
  BubbleChatDone,
  WeChat,
  BubbleChatLock,
  BubbleChatSecure,
  BubbleChatUnlock,
  BubbleChatBlocked,
  BubbleChatAdd,
  BubbleChatCancel,
  BubbleChatDownload01,
  BubbleChatDownload02,
  BubbleChatIncome,
  BubbleChatNotification,
  BubbleChatOutcome,
  BubbleChatPreview,
  BubbleChatQuestion,
  BubbleChatTranslate,
  BubbleChatUpload,
  BubbleChatUser,
  BubbleChatEdit,
  MessageDone02,
  BubbleChatFavourite,
  BubbleChatSearch,
  BubbleChatDelay,
  Comment02,
  MailOpen,
  MailOpen01,
  MailOpen02,
  MessageBlocked,
  CommentRemove02,
  MailOpenLove,
};
